// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__jRcom","Gray":"Button_Gray__jP6Qi"};